import { useInstallStore } from '@/stores/main'
import { canInstallKey } from '@/constants'

let promptInstall

export function setupBeforeInstallPrompt() {
  console.log('beforeinstallprompt-------1')
  window.addEventListener('beforeinstallprompt', (e) => {
    console.log('beforeinstallprompt-------2')
    const installStore = useInstallStore()
    promptInstall = async (cb) => {
      console.log('beforeinstallprompt-------3')
      e.prompt()
      const userChoice = await e.userChoice
      const isInstalled = userChoice.outcome === 'accepted'
      console.log('beforeinstallprompt-------4')
      cb(isInstalled)
      installStore.setInstallPrompt(false)
    }
    console.log('beforeinstallprompt-------5')
    installStore.setInstallPrompt(true)
    localStorage.setItem(canInstallKey, '1')
  })
}

export function getPromptInstall() {
  return promptInstall
}

export const IS_INSTALL_PROMPT_SUPPORTED = 'onbeforeinstallprompt' in window
